(function () {
  var requestId = 0;

  function replaceInTextNodes(root, from, to) {
    if (!root || !from || from === to) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf(from) !== -1) {
        node.nodeValue = node.nodeValue.split(from).join(to);
      }
    }
  }

  function refreshCollectionSeoMin() {
    var node = document.querySelector('[data-cp-min]');
    if (!node) return;

    var total = Number(node.getAttribute('data-cp-total') || 0);
    var previous = node.getAttribute('data-cp-min') || '';
    if (total < 1) return;

    var id = (requestId += 1);
    var pages = Math.ceil(total / 50);
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.set('view', 'min-price');

    var jobs = [];
    for (var page = 1; page <= pages; page += 1) {
      params.set('page', String(page));
      jobs.push(
        fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            return null;
          }),
      );
    }

    Promise.all(jobs).then(function (rows) {
      if (id !== requestId) return;
      if (!node.isConnected) return;

      var best = null;
      rows.forEach(function (row) {
        if (!row || row.min == null) return;
        if (!best || row.min < best.min) best = row;
      });
      if (!best) return;

      var media = node.querySelector('.seo-intro__media');
      if (media && best.url && media.getAttribute('data-hero-handle') !== best.handle) {
        media.href = best.url;
        media.setAttribute('data-hero-handle', best.handle || '');
        var img = media.querySelector('img');
        if (img && best.image) {
          img.src = best.image;
          img.removeAttribute('srcset');
          img.loading = 'lazy';
          img.decoding = 'async';
          img.setAttribute('fetchpriority', 'low');
          if (best.title) img.alt = best.title;
        }
        var title = media.querySelector('.seo-intro__price small');
        if (title && best.title) title.textContent = best.title;
        var price = media.querySelector('.seo-intro__price strong');
        if (price && best.price) price.textContent = 'od ' + best.price + ' Kč';
      }

      if (!previous || !best.price || best.price === previous) return;

      node.querySelectorAll('[data-cp-min-text]').forEach(function (spot) {
        replaceInTextNodes(spot, previous, best.price);
      });
      node.setAttribute('data-cp-min', best.price);
    });
  }

  var seoMinObserver = null;

  function scheduleCollectionSeoMin() {
    var node = document.querySelector('[data-collection-seo-section-id]');
    if (!node) return;
    if (seoMinObserver) seoMinObserver.disconnect();
    if (!('IntersectionObserver' in window)) {
      refreshCollectionSeoMin();
      return;
    }
    seoMinObserver = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (entry) {
            return entry.isIntersecting;
          })
        )
          return;
        seoMinObserver.disconnect();
        seoMinObserver = null;
        refreshCollectionSeoMin();
      },
      { rootMargin: '600px 0px' },
    );
    seoMinObserver.observe(node);
  }

  window.refreshCollectionSeoMin = scheduleCollectionSeoMin;
  scheduleCollectionSeoMin();
})();
